import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import BaseSearch from './BaseSearch'
import { fetchResultSearch, clearSearch, setFilterChanged, SearchFiltered } from '../ducks'

import { Sidebar, NotFound } from '..'

import MediaQuery from 'react-responsive'
import { ProductCardContainer } from 'Catalog/Product/ProductCard'

import InfiniteScroll from 'react-infinite-scroller'
import { Button } from 'loyal-react'
import { setMetadata } from 'Shared/HeadMetadata/ducks'

import '@loyal_template/search.css'

class ShowCase extends BaseSearch {
  shouldComponentUpdate (nextProps, nextState) {
    const propsChanged =
      JSON.stringify(nextProps) !== JSON.stringify(this.props)
    const stateChanged =
      JSON.stringify(nextState) !== JSON.stringify(this.state)

    return propsChanged || stateChanged
  }

  render () {
    let notFound =
      !this.props.isLoading &&
      (!this.props.validShowcasePage || this.props.hasNoProducts)
    if (notFound) {
      return <NotFound />
    } else {
      return (
        <div
          className={`showcase-lazy container-fluid showcase ${this.props.showcase && this.props.showcase.id} ${
            this.props.showcase && this.props.showcase.type
          }_${this.props.showcase && this.props.showcase.url}`}
        >
          <div className='container mt-5 mt-md-0 pt-4 pt-sm-5'>
            <div className={`row`}>
              <div
                className={`col-12 px-0 pt-0 pb-2 ${
                  this.state.condition
                    ? 'd-block d-md-none'
                    : 'd-none d-md-none'
                }`}
              >
                <div className='row'>
                  <div className='col-12 px-0'>
                    <Button
                      id={'button-voltar-mobile'}
                      name={'BUTTON'}
                      text='Voltar'
                      iconName='icon_left icon-sm'
                      className='col-12 btn-sm btn-flat'
                      onClick={this.handleFilter}
                    />
                  </div>
                </div>
              </div>
              <div
                className={`col-12 px-0 pt-0 pb-2 ${
                  !this.state.condition
                    ? 'd-block d-md-none'
                    : 'd-none d-md-none'
                }`}
              >
                <Button
                  id={'button-filtrar-mobile'}
                  name={'BUTTON'}
                  text='Filtrar'
                  iconName='icon_filter'
                  className='col-12 btn-sm '
                  onClick={this.handleFilter}
                />
              </div>
              <Sidebar
                subcategories={this.props.subcategories}
                brands={this.props.brands}
                vendors={this.props.vendors}
                features={this.props.features}
                handleFilterChanged={this.handleFilterChanged}
                handleFilterClean={this.handleFilterClean}
                filterSelected={this.props.filterSelected}
                priceLimit={this.props.priceLimit}
                pageType='search'
                isLoading={this.props.isLoading}
                ordination={this.state.ordination}
                className={`${
                  this.state.condition
                    ? 'd-block d-md-block'
                    : 'd-none d-md-block'
                }`}
              />

              <div
                className={`container-card col-12 col-md-8 col-lg-9 pb-5 px-half px-md-1 ${
                  !this.state.condition
                    ? 'd-block d-md-block'
                    : 'd-none d-md-block'
                }`}
              >
                <InfiniteScroll
                  initialLoad={false}
                  pageStart={0}
                  loadMore={this.loadItems}
                  hasMore={this.props.hasMoreItems}
                  loader={
                    <Button loading text='Carregando' className='btn-flat' />
                  }
                >
                  <div className='row'>
                    {this.props.products.map((product, ix) => (
                      <Fragment>
                        <MediaQuery minDeviceWidth={426}>
                          <ProductCardContainer
                            className='col-6 col-lg-4 mb-2 px-1 d-md-block'
                            sku={product.sku}
                            key={product.sku}
                          />
                        </MediaQuery>
                        <MediaQuery maxDeviceWidth={425}>
                          <ProductCardContainer
                            isResponsiveEnabled
                            className='col-12 mb-1 px-half d-block card-mobile'
                            sku={product.sku}
                            key={product.sku + '_mobile'}
                          />
                        </MediaQuery>
                      </Fragment>
                    ))}
                  </div>
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = ({ searchResult, router, oidc, participant: { clientId }, google }) => {
  const { user } = oidc
  const { profile } = user || {}
  return ({
    ...SearchFiltered(searchResult, router),
    ParticipantId: profile && profile['custom:participant_id'],
    clientId,
    profile,
    google
  })
}
const mapDispatchToProps = dispatch => ({
  fetchResultSearch: (
    term,
    identifier,
    type,
    brands,
    categories,
    subcategories,
    vendors,
    vendortype,
    features,
    minprice,
    maxprice,
    sort,
    pageIndex
  ) =>
    dispatch(
      fetchResultSearch('showcase')(
        term,
        identifier,
        type,
        brands,
        categories,
        subcategories,
        vendors,
        vendortype,
        features,
        minprice,
        maxprice,
        sort,
        pageIndex
      )
    ),
  clearSearch: () => dispatch(clearSearch()),
  setFilterChanged: (filterName, filterSelected) =>
    dispatch(setFilterChanged(filterName, filterSelected)),
  setMeta: (title, description, keywords) =>
    dispatch(setMetadata(title, description, keywords))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowCase)



// WEBPACK FOOTER //
// ./src/Catalog/Search/Search/ShowCase.js